<template>
  <label class="custom-checkbox">
    <input
      type="checkbox"
      v-model="isChecked"
      :disabled="disabled"
      @change="onChange"
    />
    <span class="checkbox-custom"></span>
    <span class="checkbox-label">{{ label }}</span>
  </label>
</template>

<script>
export default {
  name: "custom-checkbox",
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.isChecked = newVal;
    },
    isChecked(newVal) {
      this.$emit("input", newVal); // Двунаправленная связь через v-model
    },
  },
  methods: {
    onChange() {
      this.$emit("change", this.isChecked); // Отправляем событие на изменение
    },
  },
};
</script>

<style scoped>
.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
}

.custom-checkbox input {
  display: none;
}

.checkbox-custom {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  position: relative;
  background-color: #fff;
  transition: all 0.3s ease;
  @media (max-width: 767px) {
    width: 33px;
    height: 33px;
  }
}

.checkbox-custom::before {
  content: url("@/assets/images/icons/check.svg");
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.2s ease;

  @media (max-width: 767px) {
    position: absolute;
    top: 5px;
    left: 5px;
  }
}

.checkbox-label {
  font-family: UAF Sans;
  font-weight: 500;
  font-size: 24px;
  line-height: 100%;
  color: #fff;
  max-width: 650px;

  @media (max-width: 767px) {
    max-width: 310px;
    font-size: 20px;
  }
}

input:checked + .checkbox-custom::before {
  opacity: 1;
}

input:disabled + .checkbox-custom {
  background-color: #f0f0f0;
}

input:disabled:checked + .checkbox-custom::before {
  background-color: #ccc;
}
</style>
